/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import ReconMediaBatchDetailView from "./views/ReconMediaBatchDetailView";
import ReconMediaBatchListView from "./views/ReconMediaBatchListView";
import { useState } from "react";
import { ReconMediaBatchDetails } from "./reconcileMediaBatch.types";

type View = "main" | "batchDetail";

const ReconMediaBatch: React.FC = () => {
	const [currentView, setCurrentView] = useState<View>("main");
	const [selectedBatch, setSelectedBatch] =
		useState<ReconMediaBatchDetails | null>(null);

	if (currentView === "batchDetail") {
		return (
			<ReconMediaBatchDetailView
				batch={selectedBatch!}
				goBack={() => setCurrentView("main")}
			/>
		);
	} else {
		return (
			<ReconMediaBatchListView
				setCurrentView={(batch: ReconMediaBatchDetails) => {
					setSelectedBatch(batch);
					setCurrentView("batchDetail");
				}}
			/>
		);
	}
};

export default ReconMediaBatch;
